import { getCurrentLocale, isCurrentLocaleRTL } from '../domains/locales/selectors';

import { useSelector } from './useSelector';

type UseCurrentLocale = () => ReturnType<typeof getCurrentLocale>;

export const useCurrentLocale: UseCurrentLocale = () => useSelector(getCurrentLocale);

type IsCurrentLocaleRTL = () => ReturnType<typeof isCurrentLocaleRTL>;
export const useIsCurrentLocaleRTL: IsCurrentLocaleRTL = () => useSelector(isCurrentLocaleRTL);
